export default {
  unKnow: {
    code: 0,
    title: 'Unknow',
    sort: 100,
    video: ''
  },
  zip: {
    code: 5,
    title: 'Zip Codes',
    name: 'zip',
    sort: 5,
    isMulti: true,
    type: 1
  },
  zipRange: {
    code: 5,
    title: 'ZIP Code Range',
    name: 'zipRange',
    sort: 5,
    isMulti: false,
    type: 1
  },
  zipPaste: {
    code: 5,
    title: 'Paste ZIP Codes',
    name: 'zipPaste',
    sort: 5,
    isMulti: false,
    type: 1
  },
  zipSelectMap: {
    code: 5,
    title: 'Select ZIP Codes from Map',
    name: 'zipSelectMap',
    sort: 5,
    isMulti: false,
    type: 2
  },
  city: {
    code: 4,
    title: 'City',
    name: 'city',
    sort: 1,
    isMulti: true,
    type: 1
  },
  state: {
    code: 2,
    title: 'State',
    name: 'state',
    sort: 3,
    isMulti: true,
    type: 1
  },
  county: {
    code: 3,
    title: 'County',
    name: 'county',
    sort: 2,
    isMulti: true,
    type: 1
  },
  moreArea: {
    code: 23,
    name: 'moreArea',
    title: 'Multi Geo',
    sort: 20,
    video: '',
    type: 1
  },
  radius: {
    code: 16, // TODO@PONY need to fix code
    title: 'Radius Around an Address',
    name: 'radius',
    sort: 2,
    type: 2
  },
  singleradius: {
    code: 7,
    title: 'Radius Around an Address',
    name: 'singleradius',
    type: 2
  },
  polygon: {
    code: 13,
    title: 'Draw Polygon(s) from Map',
    name: 'polygon',
    sort: 3,
    type: 2
  },
  totalUSA: {
    code: 20,
    title: 'Total U.S.',
    name: 'totalUSA',
    sort: 7,
    video: '',
    type: 1
  },
  multiCount: {
    code: 24,
    name: 'multiCount',
    title: 'Multi Saved List Count',
    routeName: 'demo-multiCount',
    notGeo: true,
    isDirectCount: true,
    sort: 10,
    video: '',
    type: 1
  },
  congressionalDistrict: {
    code: 22,
    title: 'Congressional District',
    name: 'congressionalDistrict',
    sort: 8,
    type: 1
  },
  metroArea: { // msa
    code: 10,
    title: 'Metro Area',
    name: 'metroArea',
    sort: 4,
    type: 1
  },
  zipMap: { // UN Down
    code: 18,
    title: 'zip',
    type: 2
  },
  acxiomZipRadius: { // UNknow
    code: 17,
    title: 'radius',
    hideTwoDimension: true,
    type: 2
  },
  acxiomMultiRadius: { // unknow ,just in InfoUSA_IDMS_Busines, Mobile_Consumer_Advertising
    code: 16,  // 14 there is no one use 14
    title: 'radius',
    type: 2
  },
  multiClosex: { // unKnow, just for InfoUSABusiness, InfoUSAConsumer
    code: 15,
    title: 'close record',
    type: 2
  },
  Closex: {
    code: 12,
    name: 'Closex',
    title: 'Closest Records to an Address',
    hideBreakDownIfTwoDimension: true,
    video: '',
    type: 1
  },
  SCFCode: {
    code: 8,
    name: 'SCFCode',
    title: 'SCF Codes',
    sort: 6,
    type: 1
  }
}



// WEBPACK FOOTER //
// ./src/config/geoType.js